import React from 'react';
import { Breadcrumb } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { FaHome } from 'react-icons/fa'; // Home icon from react-icons
import { useBreadcrumbs } from './BreadcrumbContext';
import './Breadcrumbs.css'; // Import the CSS for additional styling

const Breadcrumbs = () => {
  const { breadcrumbs } = useBreadcrumbs(); // Access breadcrumbs

  return (
    <Breadcrumb className="custom-breadcrumb">
      {breadcrumbs.map((breadcrumb, index) => (
        <Breadcrumb.Item
          key={index}
          linkAs={Link}
          linkProps={{ to: breadcrumb.path }}
          active={index === breadcrumbs.length - 1}
          className="breadcrumb-item-custom"
        >
          {breadcrumb.path === '/' ? (
            <span className="home-icon">
              <FaHome /> Home
            </span>
          ) : (
            breadcrumb.label
          )}
        </Breadcrumb.Item>
      ))}
    </Breadcrumb>
  );
};

export default Breadcrumbs;
